/**
 * Web Style Import
 *
 */

import './style/dnb-icon.scss'
